<template>
  <el-popover
    v-if="coachStats.totalAttributionsRejected > 0"
    placement="bottom"
    title="Raisons de refus"
    :width="500"
    trigger="click"
  >
    <ul>
      <li v-if="coachStats.tooSlowResponse">
        Réponse trop lente : {{ coachStats.tooSlowResponse }}
      </li>
      <li v-if="coachStats.missingSpecialty">
        Spécialité manquante : {{ coachStats.missingSpecialty }}
      </li>
      <li v-if="coachStats.incompleteProfile">
        Profil incomplet : {{ coachStats.incompleteProfile }}
      </li>
      <li v-if="coachStats.notVerified">
        Non vérifié : {{ coachStats.notVerified }}
      </li>
      <li v-if="coachStats.betterPerformanceCoach">
        Meilleure performance d'un autre coach :
        {{ coachStats.betterPerformanceCoach }}
      </li>
      <li v-if="coachStats.femaleCoachRequest">
        Demande de coach féminin : {{ coachStats.femaleCoachRequest }}
      </li>
    </ul>

    <span
      slot="reference"
      class="popover-trigger badge badge-warning px-1 cursor-pointer"
    >
      <slot></slot>
    </span>
  </el-popover>

  <span v-else class="badge badge-info px-1">
    <slot name="fallback"></slot>
  </span>
</template>

<script>
export default {
  props: {
    coachStats: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
